import React from 'react'
import { CardProgram, DynamicContent } from '../../../../components'

import './ProgramFlashSale.scss'
import styles from './ProgramFlashSale.module.css'

const ProgramFlashSale = ({ programFlashSale, dataUser }) => {
  return (
    <article id="home-page__programFlashSale">
      <div className="container">
        <div data-aos="fade-up">
          <div className={styles.text}>
            <h2>Program Flash Sale</h2>
            {/* <p>
              Program Bootcamp dari Mindo Education untuk menunjang skill kamu
              ketika bekerja nanti di industri
            </p> */}
          </div>
        </div>
        <DynamicContent data={programFlashSale}>
          <>
            <div className={styles.programItems} data-aos="fade-up">
              {programFlashSale?.map((program, index) =>
                  <CardProgram
                    key={index}
                    program={program}
                    dataUser={dataUser}
                  />                
              )}
            </div>
          </>
        </DynamicContent>
      </div>
    </article>
  )
}

export default ProgramFlashSale
